(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["artwork-viewer"] && !Shopify.designMode) return;
  try {
    (function(){const dialog=document.getElementById('artwork-viewer');if(!dialog||!dialog.showModal)return;let trigger;document.querySelectorAll('[data-art-viewer]').forEach(link=>link.addEventListener('click',event=>{if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;event.preventDefault();trigger=link;const source=link.querySelector('img');dialog.querySelector('[data-art-image]').src=link.href;dialog.querySelector('[data-art-image]').alt=source.alt;document.getElementById('artwork-viewer-title').textContent=source.alt;dialog.querySelector('[data-art-full]').href=link.href;dialog.showModal();}));dialog.querySelector('[data-art-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>{if(trigger)trigger.focus();});})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["egyptian-study-layout"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.dog-study').forEach((section) => {
  const link = section.querySelector('[data-sheet-enlarge]');
  const dialog = section.querySelector('.lesson-sheet-dialog');
  if (link && dialog) {
    link.addEventListener('click', (event) => { if (event.metaKey || event.ctrlKey) return; event.preventDefault(); dialog.showModal(); });
    dialog.querySelector('[data-sheet-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => link.focus({ preventScroll: true }));
  }
  section.querySelectorAll('video').forEach((video) => {
    const title = video.closest('article')?.querySelector('h3') || video.closest('details')?.querySelector('summary');
    if (title) video.setAttribute('aria-label', title.textContent.trim());
    video.addEventListener('play', () => {
    section.querySelectorAll('video').forEach((other) => { if (other !== video) other.pause(); });
    });
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["open-closed-forms"] && !Shopify.designMode) return;
  try {
    function openLectureFromHash() {
  if (window.location.hash !== '#open-closed-forms') return;
  const lecture = document.getElementById('open-closed-forms');
  if (!lecture) return;
  lecture.open = true;
}
document.addEventListener('click', function(event) {
  const link = event.target.closest('a[href="#open-closed-forms"]');
  const lecture = document.getElementById('open-closed-forms');
  if (link && lecture) lecture.open = true;
});
window.addEventListener('hashchange', openLectureFromHash);
openLectureFromHash();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["signup-position"] && !Shopify.designMode) return;
  try {
    (() => {
  const key = 'tommy-signup-position';
  document.addEventListener('submit', (event) => {
    const form = event.target;
    const section = form.closest('[data-signup-section]');
    if (!section) return;
    try {
      sessionStorage.setItem(key, JSON.stringify({ id: form.id, path: location.pathname, top: section.getBoundingClientRect().top, height: form.offsetHeight, at: Date.now() }));
    } catch (_) {}
  });
  function restore() {
    let saved;
    try { saved = JSON.parse(sessionStorage.getItem(key)); } catch (_) {}
    const id = location.hash.slice(1);
    const form = document.getElementById(id);
    const section = form && form.closest('[data-signup-section]');
    if (!section || !form.matches('form')) return;
    const result = form.querySelector('[data-signup-result]');
    if (!result) return;
    const fresh = saved && saved.id === id && saved.path === location.pathname && Date.now() - saved.at < 900000;
    if (fresh) form.style.minHeight = saved.height + 'px';
    requestAnimationFrame(() => {
      const header = document.querySelector('.section-header');
      const offset = header ? Math.max(0, header.getBoundingClientRect().bottom) + 24 : 120;
      const top = fresh ? saved.top : offset;
      window.scrollTo({ top: window.scrollY + section.getBoundingClientRect().top - top, behavior: 'instant' });
      result.focus({ preventScroll: true });
      history.replaceState(history.state, '', location.pathname + location.search + '#' + section.id);
      try { sessionStorage.removeItem(key); } catch (_) {}
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restore, { once: true });
  else restore();
  window.addEventListener('load', restore, { once: true });
})();
  } catch(e) { console.error(e); }
})();

})();
